import { FulfillmentOrderAddressSchema } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { FulfillmentOrderLineItemSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-order-line-item";
import {
  MoneySchema,
  WeightSchema,
} from "@redotech/redo-fulfillment-outbound-labels-common/util";
import * as z from "zod";

const CreateFulfillmentOrderSchema_ = z.object({
  // Ship-from (origin) address: a saved location (carries locationId) or a
  // one-off custom address. Absent falls back to the team default.
  location: FulfillmentOrderAddressSchema.nullish(),
  address: FulfillmentOrderAddressSchema,
  billingAddress: FulfillmentOrderAddressSchema.nullish(),
  orderInfo: z.object({
    orderNumber: z.string(),
    secondaryOrderName: z.string().nullish(),
    // Coerced: agent code-mode tool params travel as plain JSON, so dates
    // arrive as ISO strings (regular RPC clients still pass Date instances).
    orderDate: z.coerce.date(),
    paidDate: z.coerce.date(),
    shippingPaid: MoneySchema,
    taxPaid: MoneySchema,
    totalPaid: MoneySchema,
    items: z.array(FulfillmentOrderLineItemSchema),
    internalNote: z.string(),
    orderNote: z.string().optional(),
    noteToBuyer: z.string().optional(),
    tags: z.array(z.string()).nullish(),
  }),
  customer: z
    .object({ email: z.string().nullish(), name: z.string().nullish() })
    .nullish(),
  fulfillBy: z.coerce.date().nullish(),
  requestedShippingService: z.string().nullish(),
  weight: WeightSchema.nullish(),
  salesChannel: z.string().nullish(),
  customString1: z.string().nullish(),
  customString2: z.string().nullish(),
  customString3: z.string().nullish(),
  redoOrderId: z.string().nullish(),
  orderId: z.string().nullish(),
});
export const CreateFulfillmentOrderSchema: z.ZodType<CreateFulfillmentOrder> =
  CreateFulfillmentOrderSchema_;

export interface CreateFulfillmentOrder extends z.infer<
  typeof CreateFulfillmentOrderSchema_
> {}
export interface ICreateFulfillmentOrder extends z.ZodType<CreateFulfillmentOrder> {}
